/**
 * iOS in-app · 开弹窗前选图策略
 *
 * 使用 detached `<input type="file">` + `change` + `window.focus` 延迟轮询。
 * 此路径在 commit `be750249a` 真机验证通过；**不要**改为 Host 或 session，
 * 否则 `focus` 可能在 `click()` 前触发导致「点了没反应」。
 *
 * 弹窗内 +Upload 不走本文件，见 `usePortfolioScreenshotImages`（Sender 式 onChange）。
 */
import type { PortfolioUploadType } from "@components/PortfolioScreenshotModal/types";
import { pickPortfolioFilesWithFocusFallback } from "../shared/pickPortfolioFilesWithFocusFallback";

export async function pickPortfolioFilesOnIos(
  uploadType: PortfolioUploadType,
): Promise<File[] | null> {
  return pickPortfolioFilesWithFocusFallback(uploadType);
}
